import React from "react";
import "./HimalyanDiamond.css"; // Import your CSS for styling
import prodImg from "../../assets/PackageImages/AadarshGold.png";
import { projects } from "../../data/projectsData";
import {
  Container,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { Link, useParams } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import NutritionalTable from "./NutritionalTable";
import { useMediaQuery, useTheme } from "@mui/material";

const AadarshGold = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const otherProducts = Object.values(projects).flatMap((group, index) =>
    group.map((item) => {
      return { ...item, group: `${index + 1}` };
    })
  );
  const tableData = [
    {
      nutrient: "Protein",
      value: "22%",
      comment: "Supports consistent milk production and muscle health.",
    },
    {
      nutrient: "Fat",
      value: "3%",
      comment: "Provides a reliable source of energy for lactating cows.",
    },
    {
      nutrient: "Fiber",
      value: "19%",
      comment: "Promotes better digestion and gut health.",
    },
    {
      nutrient: "Moisture",
      value: "10 - 11%",
      comment: "Keeps feed fresh and palatable.",
    },
    {
      nutrient: "Insoluble Matter",
      value: "Max 3%",
      comment: "Ensures purity and digestibility.",
    },
  ];

  return (
    <div className="product-container">
      <div className="product-details">
        <div className={isMobile ? "product-image product-image--mobile" : "product-image"}>
          <img
            src={prodImg} // Replace with the actual image path
            alt="Himalaya Diamond Premium"
          />
        </div>
        <div className="product-info">
          <div>
            <div className="product-title">
              AADARSH GOLD{" "}
              <div>
                <span
                  style={{
                    fontFamily: "Playfair Display",
                    fontStyle: "italic",
                    color: "#ffc40c",
                    fontWeight: "bold",
                    fontSize: "1.5rem",
                  }}
                >
                  IT HAS 3 SUB PRODUCTS- VITAMIN GOLD, KUBER (GREEN), ADARSH
                  GOLD
                </span>
              </div>{" "}
            </div>

            <div
              style={{
                textAlign: "justify",
              }}
            >
              <p>
                Adarsh Gold (TYPE - 2) is a high-quality cattle feed formulated
                specifically for dairy cows producing between 10 to 15 liters of
                milk per day.
              </p>
              <p>
                Crafted with a carefully selected blend of guar, rice bran,
                molasses, grains, mustard de-oiled cakes, essential vitamins,
                and minerals, this balanced feed provides all the nutrients
                needed to support your cattle's health and milk production.
              </p>
              <p>
                The inclusion of a buffer ensures optimal rumen pH levels,
                improving digestion and enhancing overall performance.
              </p>
              <p>
                Adarsh Gold is a well-rounded feed solution designed to optimize
                the performance and health of mid-yield dairy cows, helping
                farmers achieve consistent milk production while keeping their
                livestock healthy and robust.
              </p>
            </div>
          </div>
          <div>
            <h3 className="benefits-title">KEY BENEFITS:</h3>
            <div className="benefits">
              <ul>
                <li className="benefit">
                  <div>
                    <b>Supports Moderate Milk Production: </b> With 22% protein,
                    Adarsh Gold is ideal for cows producing 10 to 15 liters of
                    milk daily, ensuring consistent milk yield and overall
                    productivity.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Enhanced Digestive Health: </b>The high fiber content
                    (19%), coupled with a buffer, helps in maintaining an
                    optimal pH balance in the rumen, improving digestion and
                    preventing acidosis, leading to better nutrient absorption
                    and overall health.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Sustained Energy Levels: </b>The combination of grains,
                    molasses, and 3% fat provides a steady source of energy to
                    keep lactating cows active and productive without
                    overburdening the digestive system.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Improved Immunity and Reproductive Health: </b>The
                    addition of essential vitamins and minerals fortifies the
                    overall immunity of the cattle, while supporting
                    reproductive health, helping to reduce veterinary costs and
                    ensuring long-term productivity.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Nutrient-Rich for Overall Well-Being </b>Ingredients like
                    mustard de-oiled cakes and guar ensure that the cattle get a
                    balanced mix of essential nutrients, enhancing their health,
                    strength, and milk quality.
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div>
            <NutritionalTable isCommentPresent={true} data={tableData} />
          </div>
        </div>
      </div>

      <div className="other-products">
        <Typography variant="h6" gutterBottom>
          Products Catalogue
        </Typography>
        <List>
          {otherProducts.map((product) => {
            return (
              <ListItem
                key={product.id}
                component={Link}
                to={`/products/${product.id}`}
                style={{
                  borderBottom: "1px lightgray dotted",
                  color: "black",
                  ...(product.id === "Adarsh-gold-pellets" && {
                    backgroundColor: "#4caf50",
                    color: "white",
                    borderRadius: "1rem",
                  }),
                }}
              >
                <ListItemIcon
                  style={{
                    minWidth: "0px",
                  }}
                >
                  <ArrowForwardIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                  primary={product.title}
                />
              </ListItem>
            );
          })}
        </List>
      </div>
    </div>
  );
};

export default AadarshGold;
